import PropTypes from 'prop-types';
import FJLocalStore from '../../../store/FJLocalStore';
import FJTextToImageConstant from '../../../constants/FJTextToImageConstant';
import styles from './FJMobileRecognition.module.less';
import classNames from 'classnames';
import FJLoading from '../../../common/components/FJLoading/FJLoading';

const FJMobileRecognition = props => {
    const { promptStatus, imageUrl, onCancel } = props;
    const isShowAiOptimizing =
        promptStatus === FJTextToImageConstant.AI_OPTIMIZING || promptStatus === FJTextToImageConstant.IMAGE_IMPORTING;
    if (!isShowAiOptimizing) {
        return null;
    }
    const isShowImage = promptStatus === FJTextToImageConstant.IMAGE_IMPORTING;
    const strokeColor = isShowImage ? '#fff' : '#0000004d';
    const backgroundColor = !isShowImage ? 'transparent' : '#0000004d';
    return (
        <div className={classNames(styles.ai_optimizing_box, isShowAiOptimizing ? styles.show : '')}>
            <div className={styles.image_box}>
                {isShowImage && <img className={styles.image} src={imageUrl} />}
                <div className={styles.loading_mask} style={{ backgroundColor: backgroundColor }}>
                    <FJLoading className={styles.loading} strokeColor={strokeColor} />
                </div>
            </div>
            <div className={styles.text}>
                {promptStatus === FJTextToImageConstant.IMAGE_IMPORTING
                    ? FJLocalStore._('image-recognition')
                    : FJLocalStore._('ai-optimizing')}
            </div>
            <div className={styles.cancel} onClick={onCancel}>
                {FJLocalStore._('cancel')}
            </div>
        </div>
    );
};
FJMobileRecognition.propTypes = {
    promptStatus: PropTypes.string,
    imageUrl: PropTypes.string,
    onCancel: PropTypes.func,
};
export default FJMobileRecognition;
